import { TableColumn } from "../../../../Component/Model/Table/Table";
import { DeviationsDto } from "../../../../Component/Model/Dto/EmploymentEquity/Deviations";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { TableDateHelper } from "../../../../Component/Model/helpers";
import { PlanSummaryMovementType } from "../../../../Component/Model/Enum/EmploymentEquity";

interface PlanSummaryMovementIndividualRow {
  position: string;
  fullName: string;
  identificationNumber: string;
  employeeCode: string;
  fromOccupationalLevelName: string;
  toOccupationalLevelName: string;
  movementDate: string;
  disabled: string;
}

interface PlanSummaryMovementIndividualTableData {
  columns: Array<TableColumn>;
  rows: Array<PlanSummaryMovementIndividualRow>;
}

export function PlanSummaryMovementIndividualTableMapper(
  dataObject: DeviationsDto.PlanSummaryMovementIndividualDto[],
  movementType: PlanSummaryMovementType
): PlanSummaryMovementIndividualTableData {
  const isPromotion: boolean =
    movementType === PlanSummaryMovementType.PromotedIn || movementType === PlanSummaryMovementType.PromotedOut;

  let positionHeader: string;
  if (movementType === PlanSummaryMovementType.PromotedIn) {
    positionHeader = "Promoted Into Position";
  } else if (movementType === PlanSummaryMovementType.PromotedOut) {
    positionHeader = "Promoted Out Of Position";
  } else {
    positionHeader = "Position";
  }

  const promotionColumns: TableColumn[] = [
    {
      Header: "Promoted Out Of",
      accessor: "fromOccupationalLevelName",
      Cell: ({ value }: any) => <DefaultCell value={value} />,
      disableSortBy: true,
    },
    {
      Header: "Promoted Into",
      accessor: "toOccupationalLevelName",
      Cell: ({ value }: any) => <DefaultCell value={value} />,
      disableSortBy: true,
    },
  ];

  const columns: TableColumn[] = [
    {
      Header: positionHeader,
      accessor: "position",
      Cell: ({ value }: any) => <DefaultCell value={value} />,
    },
    {
      Header: "Name",
      accessor: "fullName",
      Cell: ({ value }: any) => <DefaultCell value={value} />,
    },
    {
      Header: "ID Number",
      accessor: "identificationNumber",
      Cell: ({ value }: any) => <DefaultCell value={value} />,
    },
    {
      Header: "Employee Code",
      accessor: "employeeCode",
      Cell: ({ value }: any) => <DefaultCell value={value} />,
    },
    ...(isPromotion ? promotionColumns : []),
    {
      Header: "Movement Date",
      accessor: "movementDate",
      Cell: ({ value }: any) => <DefaultCell value={value} />,
      disableSortBy: true,
    },
    {
      Header: "Disabled",
      accessor: "disabled",
      Cell: ({ value }: any) => <DefaultCell value={value} />,
    },
  ].map((column) => ({ ...column, noWrap: isPromotion }));

  const rows = (dataObject ?? []).map((item: DeviationsDto.PlanSummaryMovementIndividualDto) => ({
    position: item.position,
    fullName: item.fullName,
    identificationNumber: item.identificationNumber,
    employeeCode: item.employeeCode,
    fromOccupationalLevelName: item.fromOccupationalLevelName,
    toOccupationalLevelName: item.toOccupationalLevelName,
    movementDate: TableDateHelper(item.movementDate) ?? "",
    disabled: item.disabled ? "Yes" : "No",
  }));

  return { columns, rows };
}
